import { render, staticRenderFns } from "./BackendBoxedNew.vue?vue&type=template&id=dc4fbb46&"
import script from "./BackendBoxedNew.vue?vue&type=script&lang=js&"
export * from "./BackendBoxedNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports